<div class="container-fluid">
    <app-report reportId="ordersDashboard" screen="DASHBOARDORDERS"></app-report>
  </div>
